<tpl-load *ngIf="!loaded"></tpl-load>
<div id="divPreview" *ngIf="isPreview">{{ 'RESPONSE.PREVIEW_MODE' | translate }}</div>    
<div *ngIf="form != undefined" style="height: 100%;">
    <ng-container *ngIf="loaded" [formGroup]="form">
        <aw-wizard [navBarLayout]="" class="wizard-custom">
            <ng-container formGroupName='responses'>
                <aw-wizard-step formArrayName="data" awOptionalStep
                    *ngFor="let response of form.get('responses').get('data')['controls']; let i = index">
                    <ng-container formGroupName="{{i}}">
                        <tpl-video [survey]="survey" [formResponse]="form" [id_survey_audience]="id_survey_audience" [question]="getQuestionById(response.get('fk_question').value)"
                            [objColor]="objColor" [form]="response" [stepSurvey]="stepSurvey" [objVideoSettings]="objVideoSettings" (nextStep)="nextStep(i, $event)"></tpl-video>
                    </ng-container>
                </aw-wizard-step>
            </ng-container>
            <aw-wizard-step awOptionalStep>
                <thanks-message-video [survey]="survey" [objColor]="objColor" [formRespose]="form"></thanks-message-video>
            </aw-wizard-step>
        </aw-wizard>
    </ng-container>
</div>